import { render, staticRenderFns } from "./companyAccessSetting.vue?vue&type=template&id=03196b04&scoped=true&"
import script from "./companyAccessSetting.vue?vue&type=script&lang=js&"
export * from "./companyAccessSetting.vue?vue&type=script&lang=js&"
import style0 from "./companyAccessSetting.vue?vue&type=style&index=0&id=03196b04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03196b04",
  null
  
)

export default component.exports